import Chart from 'react-google-charts';
import { Card, CardBody, Col } from 'reactstrap';
 import { enhancedOptions, pieChartData } from '../../../data/dashboard/ChartData';
import { H5 } from '../../../AbstractElements';
import CardHeaderCommon from '../../../common-elements/card-header-common/CardHeaderCommon';

const OrgStatusChart = () => {
   const total = pieChartData.slice(1).reduce((sum, [, value]) => sum + Number(value), 0);

 

  return (
    <Col sm="12" xl="7" className='m-0'>
      <Card>
        <CardHeaderCommon title="Organization Distribution Overview" />
        <CardBody className="chart-block">
        
          <div className="chart-overflow" style={{ overflowX: 'auto' }}>
             <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div style={{ flex: '0 0 auto' }}>
                <Chart
                  chartType="PieChart"
                  width="300px"
                  height="200px"
                  data={pieChartData}
                  options={enhancedOptions}
                />
              </div>
              <div style={{ flex: '1', minWidth: '150px' }}>
               </div>
            </div>
             <div style={{ 
              marginTop: '10px',
              fontSize: '16px', 
              fontWeight: 'bold', 
              color: '#333',
              textAlign: 'center',
              paddingTop: '10px',
              borderTop: '1px solid #e0e0e0'
            }}>
             <H5>Total Organizations: {total}</H5> 
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default OrgStatusChart;